


































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { asuhanItemKey } from "@/utility/AsuhanKeperawatanHelper";

@Component({})
export default class ModalAskepOptions extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly title!: string;
  @Prop() selectedItems: Array<object> = [];
  @Prop() itemList = [];
  @Prop() itemColumn = 4;

  searchQuery = "";
  selected = [];
  checkedItems = [];

  get show() {
    return this.value;
  }
  set show(value) {
    this.searchQuery = "";
    this.$emit("input", value);
  }

  @Watch("selectedItems")
  changed(val) {
    // disalin, bukan dipakai langsung: kalau array induk dipegang by reference,
    // tombol Batal tidak bisa membatalkan apa pun
    this.checkedItems = (val || []).slice();
  }

  compareItems(a, b) {
    return asuhanItemKey(a) === asuhanItemKey(b);
  }

  mounted() {
    // this.checkedItems= this.selectedItems
    // this.stateGroup()
  }

  getItem() {
    this.show = false;
    this.$emit("set-order-items", this.checkedItems);
  }

  cancel() {
    this.checkedItems = (this.selectedItems || []).slice();
    this.show = false;
  }

  get filteredItems() {
    return this.itemList.filter(sub => {
      return sub.name
        .toLowerCase()
        .includes(this.searchQuery.trim().toLowerCase());
    });
  }
}
